import {getQueryString} from '../@core/api.service';

export type SimpleQueryParams = {[key: string]: string | number};

export const getWebSocketUrl = (path = '', queryParams: SimpleQueryParams = {}) => {
    const wsScheme = window.location.protocol === 'https:' ? 'wss://' : 'ws://';
    const host = window.location.host;
    return `${wsScheme}${host}/ws/${path}?${getQueryString({token: localStorage.getItem('jwt-token'), ...queryParams})}`;
};

export function getWebAddress(webAddress: string) {
    const lead: '' | '//' = webAddress.match(/^https?:\/\//) ? '' : '//';
    return lead + webAddress;
}
